import { MultiSelect } from 'primereact/multiselect';
import { SelectOption } from './financerDistributionFormat';

interface FilterMultiSelectProps {
    label: string;
    value: number[];
    options: SelectOption[];
    onChange: (values: number[]) => void;
}

/** MultiSelect con el mismo contenedor y label que Combobox/InputDate, para que la barra de filtros quede alineada. */
export default function FilterMultiSelect({ label, value, options, onChange }: FilterMultiSelectProps) {
    return (
        <div className="inputContainer flexible--column" style={{ width: '200px' }}>
            <p className="label inputLabel">{label}</p>
            <MultiSelect
                value={value}
                options={options}
                onChange={(e) => onChange(e.value)}
                placeholder="Todos"
                display="chip"
                maxSelectedLabels={1}
                aria-label={label}
            />
        </div>
    );
}
